<div class="wrapCategory">
    <div class="d-flex-center panel-title" style="margin-bottom: -5px">
        <mat-icon>category</mat-icon>
        <span>{{'general.categories' | transloco}}</span>
        <button (click)="onSelectAll()" mat-icon-button matTooltip="{{'general.selectAll' | transloco}}">
            <mat-icon>select_all</mat-icon>
        </button>
        <button (click)="onDeselectAll()" mat-icon-button matTooltip="{{'general.deselectAll' | transloco}}">
            <mat-icon>deselect</mat-icon>
        </button>
    </div>
    <div class="categories-wrapper">
        <ngx-flicking #categoriesFlicking0
                      [options]="{ bound: true, bounce: 30, align: 'prev' }"
                      [plugins]="categoriesPlugins"
                      class="categories-flicking">
            <span flicking-panel
                *ngFor="let cate of categories | slice:0:20"
                class="category"
                [ngClass]="{'selected': cate.selected}"
                (click)="selectCategory(cate)">
                {{cate.folder}}
            </span>

            <span in-viewport class="flicking-arrow-prev custom1">
                <fa-icon size="xl" [icon]="faArrowLeft"></fa-icon>
            </span>
            <span in-viewport class="flicking-arrow-next custom1">
                <fa-icon size="xl" [icon]="faArrowRight"></fa-icon>
            </span>
        </ngx-flicking>

        <ngx-flicking #categoriesFlicking1
                      [options]="{ bound: true, bounce: 30, align: 'prev' }"
                      class="categories-flicking">
        
            <span flicking-panel
                *ngFor="let cate of categories | slice:20"
                class="category"
                [ngClass]="{'selected': cate.selected}"
                (click)="selectCategory(cate)">
                {{cate.folder}}
            </span>
        </ngx-flicking>
    </div>
</div>
<div
        class="templates-wrapper"
        infinite-scroll
        [scrollWindow]="false"
        [infiniteScrollDistance]="scrollDistance"
        [infiniteScrollThrottle]="throttle"
        (scrolled)="moreTemplateCategories()">

    <div *ngFor="let templates of currentTemplates" class="panel-wrapper">
        <span class="sub-panel-title">{{templates.folder}} ({{templates.count}})</span>

        <div style="position: relative;">
            <ngx-flicking
                    class="flicking"
                    [options]="flickConfig"
                    [plugins]="templates.plugins"
                    (needPanel)="moreTemplateItems(templates.folder)">

                <div flicking-panel *ngFor="let item of templates.items; let i = index"
                     class="panel fade-in-item"
                     [style.animation-delay]="(i * 100) + 'ms'">
                    <div [ngSwitch]="templates.folder" class="template-wrapper">
                        <div *ngSwitchCase="'Background horizontal'">
                            <img alt="" class="imgBGH" [src]="item.url">
                        </div>
                        <div *ngSwitchCase="'Background vertical'">
                            <img alt="" class="imgBGV" [src]="item.url">
                        </div>
                        <div *ngSwitchCase="'Vertical'">
                            <img alt="" class="imgV" [src]="item.url">
                        </div>
                        <div *ngSwitchDefault>
                            <img alt="" class="imgH" [ngClass]="{'large': largeCategories.includes(templates.folder)}" [src]="item.url">
                        </div>
                        <div class="title">{{item.sceneTitle}}</div>
                        <div class="overlay">
                            <a style="background-color: #0d66c2" mat-icon-button class="mini-button jump-icon" (click)="openImportDialog(item)" matTooltip="{{'general.createSceneFromTemplate' | transloco}}">
                                <mat-icon style="color: white">download</mat-icon>
                            </a>
                        </div>
                    </div>
                </div>
                <span in-viewport class="flicking-arrow-prev">
                    <fa-icon size="2xl" [icon]="faArrowLeft"></fa-icon>
                </span>
                <span in-viewport class="flicking-arrow-next">
                    <fa-icon size="2xl" [icon]="faArrowRight"></fa-icon>
                </span>
            </ngx-flicking>
        </div>

    </div>
</div>
